module.exports = __webpack_public_path__ + "img/archive-hover.5cc1f930.svg";